@let title = text();
@if (title && !question.source) {
  <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
}
@for (group of groups; track group.index) {
  @if (!$first) {
    <hr>
  }

  @if (question.source) {
    <h5 id="group-heading-{{ group.index }}" tabindex="-1" [class.upper-border]="$index !== 0">{{ group.name }}</h5>
  }
  @for (question of group.questions; track question.id) {
    <div class="position-relative control"
         [class.has-validation-error]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]">
      <!-- Show as a summary -->
      @if (group.locked) {
        <display-control
          [first]="$index === 0"
          [group]="group"
          [question]="question"
          [answer]="question.calculatedResponse!"></display-control>

      } @else {
        @if (question.type!.endsWith("TEXT")) {
          <text-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"></text-control>

        } @else if (question.type === "NOTE" ) {
          <confirm-option-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "CHECKBOX") {
          <checkbox-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        }  @else if (question.type === "RADIO" || question.type === "CONFIRM_OPTION") {
          <radio-button-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "DROPDOWN") {
          <dropdown-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "CURRENCY") {
          <currency-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "EMAIL") {
          <email-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "NUMBER") {
          <number-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "PERCENTAGE") {
          <percentage-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "POSTCODE") {
          <postcode-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [groupIndex]="group.index"
            [question]="question"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>

        } @else if (question.type === "DATE") {
          <date-control
            #questionControl
            [standalone]="false"
            [baseForm]="baseForm"
            [form]="this.form"
            [id]="question.id + '-wrapper'"
            [questionId]="question.id!"
            [question]="question"
            [groupIndex]="group.index"
            [editingResponse]="editingResponse"
            [onEnter]="onEnter"
            [hasValidationError]="baseForm.interviewState()?.errors?.validations && baseForm.interviewState()!.errors!.validations![question.id!]"/>
        }
      }
    </div>
  }

  @if (!question.source) {
    <div class="form-group position-relative row mb-2">

      <div class="col-6">
        <!-- Only allow deletion if there's more than 1 group -->
        @if (groups.length > 1) {
          <div class="outer-button">
            <button class="btn tertiary delete rounded-pill submit" id="delete-{{group.name}}-{{group.index}}"
                    type="button" (click)="delete(group)" (keyup.enter)="delete(group)">
              @if (baseForm.loading) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              {{ messages.getText('btn.remove', 'Remove entry') }}
            </button>
          </div>
        }
      </div>
      <div class="col-6">
        @if ($last) {
          <div class="outer-button">
            <button class="btn tertiary add rounded-pill submit pull-right" id="add-{{ groupName }}"
                    type="button" (click)="addGroup()" (keyup.enter)="addGroup()">
              @if (baseForm.loading) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              {{ messages.getText('btn.add-another', 'Add another entry') }}
            </button>
          </div>
        }
      </div>
    </div>
  }
}

@if (changedMindQuestion; as cmq) {
  <div id="changed-mind" class="mt-8 alert alert-query" role="alert">
    <checkbox-control #changedMindControl
                      [baseForm]="baseForm"
                      [form]="form"
                      [id]="cmq.id + '-wrapper'"
                      [questionId]="cmq.id!"
                      [question]="cmq"
                      [standalone]="false"
                      [onEnter]="onEnter">
    </checkbox-control>
  </div>
}

@if (baseForm.interviewState()?.errors?.validations) {
  <div class="alert alert-warning warning pill form-warning-list row my-3" [attr.aria-live]="'assertive'">
    <i class="fa fa-info-circle col-1 my-auto" aria-hidden="true"></i>
    <ul class="col-10 my-3 mx-3">
      @for (message of uniqueValidationMessages; track $index) {
        <li>{{ message }}</li>
      }
    </ul>
  </div>
}

<div class="option-row row px-0 mt-8 mx-0">
  <div class="col px-0 text-end">
    <button class="btn primary rounded-pill confirm-button"
            [disabled]="baseForm.loading || baseForm.preventSave"
            [attr.aria-label]="getLabel() + '.confirm_button'"
            (click)="saveAndContinue($event)"
            (keydown.enter)="saveAndContinue($event)">
      @if (baseForm.loading) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
      }
      {{ messages.getText('WILL.button.save-and-continue') }}
    </button>
  </div>
</div>

